import { IconButton, TableCell, TableRow } from '@material-ui/core'
import { RemoveCircle } from '@material-ui/icons'
import React from 'react'
import { Field } from '../../form'
import classNames from 'classnames'

const LinkRowComponent = ({
  t,
  index,
  classes,
  control,
  link_removeRow,
  // IsNotOpenForWork,
  link_title,
  link_url,
  setIsDirty
}) => {
  return (
    <TableRow className="row-style">
      <TableCell className={classes.tableCell}>
        <Field
          name={link_title}
          label={t('openForWork.label11a')}
          inputType="textfield"
          control={control}
          className={classNames(classes.textfield)}
          // disabled={IsNotOpenForWork}
          style={{ width: '90%' }}
          labelStyle={{ fontSize: '14px' }}
          onChange={() => {
            setIsDirty(true)
          }}
        />
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Field
          name={link_url}
          label={t('openForWork.label11b')}
          inputType="textfield"
          control={control}
          className={classNames(classes.textfield)}
          // disabled={IsNotOpenForWork}
          labelStyle={{ fontSize: '14px' }}
          onChange={() => {
            setIsDirty(true)
          }}
        />
      </TableCell>
      <TableCell className={classes.tableCell}>
        {index > 0 && (
          <div className="pull-right">
            <IconButton
              component="span"
              className={classes.buttonFile}
              // disabled={IsNotOpenForWork}
              size="medium"
              style={{
                color: '#F67131',
                marginTop: '40px'
              }}
              onClick={() => {
                link_removeRow(index)
                setIsDirty(true)
              }}
              key={index}
            >
              <RemoveCircle fontSize="medium" />
            </IconButton>
          </div>
        )}
      </TableCell>
    </TableRow>
  )
}

export default LinkRowComponent
